import request from "@/utils/request";

export default {
    // 生成订单编号
    generateOrderNumber() {
        return request.get('/api/orders/generate_number');
    },

    // 创建订单
    createOrder(data) {
        return request.post('/api/orders', data);
    },

    // 查询订单详情
    inquireOrder(orderId) {
        return request.get(`/api/orders/${orderId}`);
    },

    // 查询订单列表
    inquireOrders(params) {
        return request.get('/api/orders', { params });
    },

    // 删除订单
    deleteOrder(orderId) {
        return request.delete(`/api/orders/${orderId}`);
    },

    // 获取客户商品价格
    getCustomerMerchandisePrice(customerId, merchandiseId) {
        return request.get('/api/orders/customer_price', {
            params: { customer_id: customerId, merchandise_id: merchandiseId }
        });
    },

    // 筛选
    filterOrders(params) {
        return request.get('/api/orders/filter', { params })
    },

    // 改
    updateOrder(orderId, data) {
        return request.put(`/api/orders/${orderId}`, data)
    }
};